/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountRequestSpec } from './accountRequestSpec';


export interface AccountsOnboardRequestSpec { 
    /**
     * Accounts id\'s
     */
    account_ids: Array<string>;
    metadata: AccountRequestSpec;
}

